import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface FullscreenDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
}

export function FullscreenDialog({ open, onOpenChange, title, children }: FullscreenDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="!h-screen !max-h-screen !w-screen !max-w-[100vw] flex flex-col p-0 gap-0 rounded-none data-[state=open]:!w-screen"
        style={{ maxWidth: '100vw', width: '100vw', height: '100vh' }}>
        {title && (
          <DialogHeader className="p-6 pb-4 border-b shrink-0">
            <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>
          </DialogHeader>
        )}
        <div className="flex-1 flex flex-col min-h-0">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
